import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2d12c990")

_pushScopeId("data-v-2d12c990")
const _hoisted_1 = {
  key: 1,
  class: "team__image",
  style: { backgroundColor: '#efefef'}
}
const _hoisted_2 = { class: "team__header" }
const _hoisted_3 = {
  key: 1,
  class: "team__date"
}
const _hoisted_4 = {
  key: 0,
  class: "team__stats"
}
const _hoisted_5 = {
  key: 0,
  class: "team__rank"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("i", { class: "icon-trophy" }, null, -1)
const _hoisted_7 = {
  key: 1,
  class: "team__captain icon-crown"
}
const _hoisted_8 = {
  key: 0,
  class: "icon-star"
}
const _hoisted_9 = {
  key: 1,
  class: "icon-star-empty"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_TeamLabel = _resolveComponent("TeamLabel")
  const _component_ConfirmAction = _resolveComponent("ConfirmAction")

  return (_openBlock(), _createBlock("div", {
    class: ["team__container", {'disabled': _ctx.isRemoving, 'background-color': _ctx.teamColor}]
  }, [
    (_ctx.hasTeamPicture)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          class: "team__image",
          style: { backgroundImage: `url(${_ctx.teamPictureUrl})`}
        }, null, 4))
      : (_openBlock(), _createBlock("div", _hoisted_1)),
    _createVNode("div", {
      class: "team__item",
      onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.gotoTeam && _ctx.gotoTeam(...args)), ["stop"]))
    }, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", {
          class: ["team__name", {'team__name--padded':_ctx.canEdit}]
        }, _toDisplayString(_ctx.teamName), 3),
        (_ctx.showTeamLogo)
          ? (_openBlock(), _createBlock(_component_TeamLabel, {
              key: 0,
              teamName: false,
              team: _ctx.team,
              link: false,
              class: "team__logo"
            }, null, 8, ["team"]))
          : _createCommentVNode("", true),
        (_ctx.joinYearVisible)
          ? (_openBlock(), _createBlock("span", _hoisted_3, "Depuis " + _toDisplayString(_ctx.teamJoin), 1))
          : _createCommentVNode("", true)
      ]),
      (_ctx.hasStats)
        ? (_openBlock(), _createBlock("div", _hoisted_4, [
            _createVNode("span", null, "Points: " + _toDisplayString(_ctx.stats.points), 1),
            _createVNode("span", null, "Victoires: " + _toDisplayString(_ctx.stats.win), 1),
            _createVNode("span", null, "Defaites: " + _toDisplayString(_ctx.stats.lost), 1),
            _createVNode("span", null, "Nulles: " + _toDisplayString(_ctx.stats.nul), 1),
            (_ctx.hasRank)
              ? (_openBlock(), _createBlock("div", _hoisted_5, [
                  _hoisted_6,
                  _createTextVNode(_toDisplayString(_ctx.rank), 1)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.isTeamCaptain)
        ? (_openBlock(), _createBlock("i", _hoisted_7))
        : (_ctx.isBasicUser)
          ? (_openBlock(), _createBlock("div", {
              key: 2,
              class: "team__favorite",
              onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleFavoriteTeam && _ctx.toggleFavoriteTeam(...args)), ["stop"]))
            }, [
              (_ctx.favoriteTeam)
                ? (_openBlock(), _createBlock("i", _hoisted_8))
                : (_openBlock(), _createBlock("i", _hoisted_9))
            ]))
          : _createCommentVNode("", true),
      (_ctx.canEdit)
        ? (_openBlock(), _createBlock("i", {
            key: 3,
            class: "card__edit icon-sketch",
            onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.editTeam && _ctx.editTeam(...args)), ["stop","prevent"]))
          }))
        : _createCommentVNode("", true),
      (_ctx.canEdit)
        ? (_openBlock(), _createBlock("div", {
            key: 4,
            class: "card__remove",
            onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop","prevent"]))
          }, [
            _createVNode(_component_ConfirmAction, {
              type: "delete",
              onConfirm: _ctx.removeTeam
            }, null, 8, ["onConfirm"])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
})